import { InspectorControls } from "@wordpress/block-editor";
import {
    PanelBody,
    TextControl,
    __experimentalView as View,
} from "@wordpress/components";

const { addFilter } = wp.hooks;

// Dodanie nowego atrybutu do bloku cover
const coverMobileVideoExtension = (settings, name) => {
    if (name !== "core/cover") {
        return settings;
    }

    const existingAttributes = settings.attributes || {};

    return {
        ...settings,
        attributes: {
            ...existingAttributes,
            mobileVideoUrl: {
                type: "string",
                default: "",
            },
            desktopVideoUrl: {
                type: "string",
                default: "",
            },
        },
    };
};

// Dodanie kontrolek do edytora
const withCoverMobileVideoControls = wp.compose.createHigherOrderComponent(
    (BlockEdit) => {
        return (props) => {
            if (props.name !== "core/cover") {
                return <BlockEdit {...props} />;
            }

            const { attributes, setAttributes, clientId } = props;

            // Zapisz oryginalny URL wideo przy pierwszym renderowaniu
            React.useEffect(() => {
                const videoElement = document.querySelector(
                    `#block-${clientId} video`
                );
                if (videoElement && !attributes.desktopVideoUrl) {
                    setAttributes({ desktopVideoUrl: videoElement.src });
                }
            }, []);

            // Obsługa zmiany rozmiaru ekranu w edytorze
            React.useEffect(() => {
                const handleResize = () => {
                    const videoElement = document.querySelector(
                        `#block-${clientId} video`
                    );
                    if (!videoElement) return;

                    if (window.innerWidth <= 768 && attributes.mobileVideoUrl) {
                        videoElement.src = attributes.mobileVideoUrl;
                    } else if (attributes.desktopVideoUrl) {
                        videoElement.src = attributes.desktopVideoUrl;
                    }
                };

                window.addEventListener("resize", handleResize);
                handleResize(); // Wywołaj od razu przy montowaniu

                return () => window.removeEventListener("resize", handleResize);
            }, [attributes.mobileVideoUrl, attributes.desktopVideoUrl]);

            return (
                <>
                    <BlockEdit {...props} />
                    <InspectorControls>
                        <PanelBody title="Mobile Video" initialOpen={true}>
                            <TextControl
                                label="Mobile Video URL"
                                value={attributes.mobileVideoUrl}
                                onChange={(value) => {
                                    setAttributes({
                                        mobileVideoUrl: value,
                                    });
                                    // Aktualizuj źródło wideo jeśli jesteśmy na mobile
                                    if (window.innerWidth <= 768) {
                                        const videoElement =
                                            document.querySelector(
                                                `#block-${clientId} video`
                                            );
                                        if (videoElement) {
                                            videoElement.src = value;
                                        }
                                    }
                                }}
                                help="Enter the URL for mobile video (will be used below 768px)"
                            />
                        </PanelBody>
                    </InspectorControls>
                </>
            );
        };
    },
    "withCoverMobileVideoControls"
);

// Dodanie dodatkowych właściwości do zapisanego bloku
const addCoverMobileVideoProps = (extraProps, blockType, attributes) => {
    if (blockType.name !== "core/cover") {
        return extraProps;
    }

    if (attributes.mobileVideoUrl) {
        extraProps.className = extraProps.className
            ? `${extraProps.className} has-responsive-video`
            : "has-responsive-video";

        extraProps["data-mobile-video"] = attributes.mobileVideoUrl;
        extraProps["data-desktop-video"] = attributes.desktopVideoUrl;
    }

    return extraProps;
};

// Rejestracja filtrów
addFilter(
    "blocks.registerBlockType",
    "danone/cover-mobile-video-attributes",
    coverMobileVideoExtension,
    20
);

addFilter(
    "editor.BlockEdit",
    "danone/with-cover-mobile-video-controls",
    withCoverMobileVideoControls,
    20
);

addFilter(
    "blocks.getSaveContent.extraProps",
    "danone/cover-mobile-video-props",
    addCoverMobileVideoProps
);

// Dodaj skrypt inicjalizujący na frontend
document.addEventListener("DOMContentLoaded", () => {
    const handleVideoResponsiveness = () => {
        document.querySelectorAll(".has-responsive-video").forEach((cover) => {
            const video = cover.querySelector("video");
            if (!video) return;

            const mobileUrl = cover.dataset.mobileVideo;
            const desktopUrl = cover.dataset.desktopVideo;

            if (window.innerWidth <= 768 && mobileUrl) {
                if (video.src !== mobileUrl) {
                    video.src = mobileUrl;
                }
            } else if (desktopUrl) {
                if (video.src !== desktopUrl) {
                    video.src = desktopUrl;
                }
            }
        });
    };

    // Inicjalne sprawdzenie
    handleVideoResponsiveness();

    // Nasłuchiwanie na zmiany rozmiaru okna
    window.addEventListener("resize", handleVideoResponsiveness);
});
